import { render, staticRenderFns } from "./MoreButton.vue?vue&type=template&id=09b530f2"
import script from "./MoreButton.vue?vue&type=script&lang=js"
export * from "./MoreButton.vue?vue&type=script&lang=js"
import style0 from "./MoreButton.vue?vue&type=style&index=0&id=09b530f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports